import FileDetail from "../controllers/Repository/FileDetail";
import { rows, DataGrid, Dropzone, DragAndDropInfo } from "colbi_web_ui/lib/components";
import { StackLayout } from "../layouts";
import { parseFilter } from "colbi_web_ui/lib/utils";
import Repository from "../controllers/App/Repository";
import RepositoryTabs from "../components/RepositoryTabs/RepositoryTabs";
import RepositoryToolbar from "../components/RepositoryToolbar/RepositoryToolbar";
import UploadFormHeaderButtons from "../components/RepositoryUploadButton/UploadFormHeaderButtons";
import { REACT_APP_DEFAULT_PAGE_SIZE } from "../environmentVariables";

const buildDatagrid = (dragAndDropActive) => {
    const datagridProps = {
        id: "results",
        card: rows.CellCard,
        checkbox: true,
        items: "query(0).list",
        header: "query(0).header",
        footer: "query(0).footer",
        metadata: "query(0).metadata",
        page: "param(page)",
        status: "status(0)",
        sort: "param(sort)",
        pageSize: "param(pageSize)",
        pageDefault: 10,
        filter: "param(filter)",
        availableFilters: "query(0).filters",
        wrapper: "wrapper",
        showCheckbox: "query(0).showCheckbox",
        total: "query(0).metadata.total",
        projectModules: "query(2)",
        toolbar: RepositoryToolbar,
    };
    return dragAndDropActive
        ? [
              {
                  component: DragAndDropInfo,
                  props: {
                      csvDelimiter: "query(3)",
                  },
              },
              {
                  component: Dropzone,
                  props: {
                      Children: DataGrid,
                      childrenProps: datagridProps,
                      modifiers: ["--root-margin-top-small", "--row-style-alternate"],
                  },
              },
          ]
        : [
              {
                  component: DataGrid,
                  props: datagridProps,
                  modifiers: ["--root-margin-top-small", "--row-style-alternate"],
              },
          ];
};

const queries = (args = {}) => {
    return [
        {
            resource: args.section,
            args: {
                projectId: args.projectId,
                fiscalYear: args.fiscalYear || "",
                fileType: args.fileType || "",
                sort: args.sort
                    ? { type: "[SortInput!]", value: parseFilter(args.sort) }
                    : undefined,
                filter: args.filter
                    ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                    : undefined,
                page: parseInt(args.page, 10) || 0,
                pageSize: parseInt(args.pageSize || REACT_APP_DEFAULT_PAGE_SIZE),
            },
            body: `__typename, items{...${args.section}}, total, hasMore,filters(projectId:$projectId, fiscalYear:$fiscalYear){ prop, name, type, list, disableOperators, mandatory}`,
            downloadable: true,
            forceRefresh: true,
            isDatagridReq: true,
        },
        {
            resource: "show_terms_and_conditions",
            args: {
                projectId: args.projectId,
            },
            forceRefresh: true,
        },
        {
            resource: "project_modules",
            args: {
                projectId: args.projectId,
            },
            body: "modules",
        },
        {
            resource: "csv_delimiter",
            args: {
                projectId: args.projectId,
            },
            forceRefresh: true,
        },
        args.id
            ? {
                  resource: `${args.section}_detail`,
                  args: {
                      projectId: args.projectId,
                      fiscalYear: args.fiscalYear,
                      id: args.id,
                      locale: args.locale || "",
                  },
                  body: `...${args.section}_detail`,
              }
            : {},
    ].filter((r) => !!r.resource);
};

const repository = (path, navigation, dragAndDropActive = false) => ({
    path,
    navigation,
    component: Repository,
    exact: false,
    queries,
    title: "files",
    buttonConfig: {
        showButton: true,
        label: "Upload",
        type: "repository",
        action: UploadFormHeaderButtons,
    },
    components: [
        {
            component: RepositoryTabs,
            props: {
                path: path,
            },
        },
        ...buildDatagrid(dragAndDropActive),
    ],
    routes: [
        {
            path: "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/:importId/repository/:section/:id",
            exact: true,
            queries,
            component: StackLayout,
            components: [
                {
                    component: FileDetail,
                    props: {
                        modules: "query(2)",
                        data: "query(4)",
                    },
                },
            ],
        },
    ],
});

export default repository;
